<template>
<transition name="fade" mode="out-in">

    <div class="pane" v-show="show">
        <slot></slot>
    </div>

</transition>
</template>
<script>
export default {
    name:'pane',
    data(){
        return{
            show:true
        }
    },
    props:{
        name:{
            type:String
        },
        label:{
            type:String,
            default:''
        },
        closable:{
            type:Boolean,
            default:true
        }
    },
    methods:{
        updateNav(){
            this.$parent.updateNav();
        }
    },
    watch:{
        label(){
            this.updateNav();
        },

    },
    mounted(){
        this.updateNav();
    },
    beforeDestroy(){
        
    }
}
</script>
<style>
.pane{
    display: inline-block;
}
 .fade-enter-active,.fade-leave-active{
     position: absolute;
     transition: all .8s ease;
}
.fade-enter, .fade-leave-to{
    transform: translateX(100px);
    opacity: 0;
}
</style>
